module.exports = __webpack_public_path__ + "static/media/circle2.2639b71c.svg";